import { Component } from '@angular/core';
import { PatientLinkTableFactory } from '../../grid-table-factory';
import { RelationRequestTableFactory } from '../../grid-table-factory/user-relation-requests-table';
import { RELATION_REQUESTS_PAGE_CONFIG, RELATION_REQUESTS_TABLES } from '../../relation-request.tokens';

import { UsersSearchService } from 'src/app/components/search/users-search.service';
import { SuggestedPatientTable } from '../../grid-table-factory/patient-link-tables/suggested-patient-table';
import { UserSearchTableConstructor } from '../../grid-table-factory/search-table';
import { PatientLinkRequestService } from '../../services/patient-link-request.service';
import { UserRelationRequestService } from '../../services/relation-request.service';
import { ManageRelationRequestComponent } from '../manage-relation-request/manage-relation-request.component';
import { PATIENT_LINK_TABLES, PATIENT_PAGE_CONFIG, PatientLinkRequestComponent } from './manage-patient-link';

@Component({
  selector: 'patient-links-page',
  templateUrl: './patient-links-page.html',
  styleUrls: ['./patient-links-page.component.scss'],
  providers: [
    UsersSearchService,
    { provide: ManageRelationRequestComponent, useClass: PatientLinkRequestComponent },
    { provide: UserRelationRequestService, useClass: PatientLinkRequestService },
    { provide: RelationRequestTableFactory, useClass: PatientLinkTableFactory },
    { provide: UserSearchTableConstructor, useClass: SuggestedPatientTable },
    { provide: RELATION_REQUESTS_TABLES, useValue: PATIENT_LINK_TABLES },
    { provide: RELATION_REQUESTS_PAGE_CONFIG, useValue: PATIENT_PAGE_CONFIG },
  ],
})
export class PatientLinksPageComponent {}
